import { RootState } from '../types'
import { CartDetails, UserAddress, UserType } from './types'

export const selectIsCartDrawerOpen = (state: RootState): boolean => state.cart.isCartDrawerOpen

export const selectCartDetails = (state: RootState): CartDetails =>
  state.cart.cartDetails || ({} as CartDetails)

export const selectUserType = (state: RootState): string => state.cart.userType

export const selectUserAddress =
  (userType: UserType) =>
  (state: RootState): UserAddress =>
    state.cart.cartDetails[userType]
